module.exports = __webpack_public_path__ + "img/402(1)f.6de7b6ed.png";